"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChart = PieChart;
var React = require("react");
var d3 = require("d3");
var d3Hoc = function (renderFn, dependencies) {
    var ref = React.useRef();
    React.useEffect(function () {
        renderFn(d3.select(ref.current));
        return function () {
            /** */
        };
    }, dependencies);
    return ref;
};
function PieChart(props) {
    var ref = d3Hoc(function (div) {
        var margin = { left: 20, right: 20, top: 20, bottom: 20 };
        var outerWidth = props.width;
        var outerHeight = props.height;
        var width = outerWidth - margin.left - margin.right;
        var height = outerHeight - margin.top - margin.bottom;
        var r = Math.min(width, height) / 2;
        var arc = d3
            .arc()
            .outerRadius(r)
            .innerRadius(r - 15);
        var arcHover = d3
            .arc()
            .outerRadius(r + 3)
            .innerRadius(r - 15);
        div.selectAll('svg').remove();
        var svg = div
            .append('svg')
            .style('width', "".concat(outerWidth, "px"))
            .style('height', "".concat(outerHeight, "px"))
            .attr('width', outerWidth)
            .attr('height', outerHeight);
        var tooltip = div
            .append('div')
            .attr('class', 'sok-tooltip-box')
            .style('position', 'absolute')
            .style('visibility', 'hidden')
            .style('opacity', 0);
        var pie = d3.pie().value(function (d) { return d.value; });
        svg.append('g').attr('transform', "translate(".concat(margin.left, ",").concat(margin.top, ")"));
        svg
            .append('g')
            .selectAll('path')
            .data(pie(props.data))
            .enter()
            .append('path')
            .attr('class', 'arc')
            .attr('transform', "translate(".concat(outerWidth / 2 - margin.left / 2, ",").concat(outerHeight / 2 - margin.top / 2, ")"))
            .attr('d', arc)
            .on('mouseover', function (event, d) {
            d3.select(this).transition().duration(500).attr('d', arcHover);
            var total = d3.sum(props.data.map(function (d) {
                return d.value;
            }));
            var percent = Math.round((100 * d.data.value) / total);
            tooltip
                .style('left', event.pageX + 'px')
                .style('top', event.pageY + 'px')
                .style('visibility', 'visible')
                .style('opacity', 1)
                .text("".concat(percent, " %"));
        })
            .on('mouseout', function (e) {
            d3.select(this).transition().duration(500).attr('d', arc);
            tooltip.style('visibility', 'hidden').style('opacity', 0);
        });
        svg.selectAll('path').style('fill', function (d, i) { return d.data.color; });
        var legend = svg
            .append('g')
            .attr('class', 'legend')
            .attr('transform', 'translate(0,' + 36 + ')');
        var lg = legend
            .selectAll('g')
            .data(props.data)
            .enter()
            .append('g')
            .attr('transform', function (d, i) { return "translate(".concat(i * 100, ",0)"); });
        lg.append('rect')
            .style('fill', function (d) { return d.color; })
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', 16)
            .attr('height', 16);
        lg.append('text')
            .style('font-family', '"Roboto", sans-serif')
            .style('font-size', '14px')
            .attr('x', 20)
            .attr('y', 12)
            .text(function (d) { return d.label; });
        var offset = 0;
        lg.attr('transform', function (d, i) {
            var x = offset;
            offset += this.getBBox().width + 30;
            return "translate(".concat(x, ",").concat(height - 10, ")");
        });
        legend.attr('transform', function () {
            return "translate(".concat((width - this.getBBox().width) / 2, ",30)");
        });
    }, props.data);
    return (React.createElement("div", { ref: ref, style: {
            height: props.height,
            width: props.width
        } }));
}
